export { default as AddUserIcon } from './add-icon.svg';
export { default as ArrowLeft } from './arrow-left.svg'; // TODO: these are thorn branded
export { default as ArrowRight } from './arrow-right.svg'; // TODO: these are thorn branded
export * from './assetIcons';
export { default as CheckedIcon } from './checkedIcon.svg';
export { default as ContractDark } from './contract-dark.svg';
export { default as IconArrowsVertical } from './icon-arrows-vertical.svg';
// backward compat: IconAssetWatercraft key continues to resolve (TSX set renamed it to IconAssetBoat)
export { IconAssetBoat as IconAssetWatercraft } from './assetIcons';
export { default as IconBookmark } from './icon-bookmark.svg';
export { default as IconFinance } from './icon-carbon-finance.svg';
export { default as IconSun } from './icon-carbon-sun.svg';
export { default as IconCash } from './icon-cash.svg';
export { default as IconCertificateCheck } from './icon-certificate-check.svg';
export { default as IconChart } from './icon-chart.svg';
export { default as DashboardChartIcon } from './icon-chart-column.svg';
export { default as IconCheckmark } from './icon-checkmark.svg';
export { default as IconCheckMarkOutline } from './icon-checkmark-outline.svg';
export { default as ChevronLeft } from './icon-chevron-left.svg';
export { default as ChevronRight } from './icon-chevron-right.svg';
export { default as IconClose } from './icon-close.svg';
export { default as DarkConfidential } from './icon-dark-confidential.svg';
export { default as IconDocument } from './icon-document.svg';
export { default as IconDocumentAdd } from './icon-document-add.svg';
export { default as IconDocumentAttachment } from './icon-document-attachment.svg';
export { default as IconDocumentSign } from './icon-document-sign.svg';
export { default as IconDocumentUpload } from './icon-document-upload.svg';
export { default as IconFilter } from './icon-filter.svg';
export { default as IconFire } from './icon-fire.svg';
export { default as IconGoShieldLock } from './icon-go-shield-lock.svg';
export { default as IconIce } from './icon-ice.svg';
export { default as IconImage } from './icon-image.svg';
export { default as LightContract } from './icon-light-contract.svg';
export { default as IconLogout } from './icon-logout.svg';
export { default as IconMap } from './icon-map.svg';
export { default as AuthenticatorApp } from './icon-mobile-authenticator.svg';
export { default as WhiteChatIcon } from './icon-mobile-sms.svg';
export { default as IconMoney } from './icon-money.svg';
export { default as DotsMenuIcon } from './icon-overflow-menu-vertical.svg';
export { default as IconPackage } from './icon-package.svg';
export { default as IconPhone } from './icon-phone.svg';
export { default as IconRocket } from './icon-rocket.svg';
export { default as IconSchedule } from './icon-schedule.svg';
export { default as IconStarFilled } from './icon-star-filled.svg';
export { default as IconStarNonFilled } from './icon-star-nonfilled.svg';
export { default as IconStateCheckFail } from './icon-state-check-fail.svg';
export { default as IconStateCheckIncomplete } from './icon-state-check-incomplete.svg';
export { default as IconStateCheckPass } from './icon-state-check-pass.svg';
export { default as IconStateCheckWarning } from './icon-state-check-warning.svg';
export { default as IconThumbUp } from './icon-thumb-up.svg';
export { default as IconThumbsUp } from './icon-thumbs-up.svg';
export { default as IconTimer } from './icon-timer.svg';
export { default as IconTrash } from './icon-trash.svg';
export { default as IconWarning } from './icon-warning.svg';
export { default as IconWarningAlt } from './icon-warning-alt.svg';
export { IconCall } from './IconCall';
export { IconEmail } from './IconEmail';
export * from './InceptIcon';
export { default as InputPasswordEye } from './input-password-eye.svg';
export { default as Logout } from './log-out.svg';
export { default as MinusIcon } from './minusIcon.svg';
export { default as PhoneCallDark } from './phone-call-dark.svg';
export { default as PriorityHighIcon } from './priority-high.svg';
export { default as PriorityLowIcon } from './priority-low.svg';
export { default as PriorityMediumIcon } from './priority-medium.svg';
export { SecurityIcon as Security } from './SecurityIcon';
export { default as Sparkles } from './sparkles.svg';
export { default as ThumbsUpDark } from './thumbs-up-dark.svg';
